export default "__VITE_ASSET__BHm9GGri__"